import { render, staticRenderFns } from "./SidebarContainer.vue?vue&type=template&id=57edf6e8&scoped=true"
import script from "./SidebarContainer.vue?vue&type=script&lang=ts"
export * from "./SidebarContainer.vue?vue&type=script&lang=ts"
import style0 from "./SidebarContainer.vue?vue&type=style&index=0&id=57edf6e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57edf6e8",
  null
  
)

export default component.exports